"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var Shape_1 = __importDefault(require("./Shape"));
// Some versions of Safari doesn't support BigUint64Array and friends, and
// it's not possible to polyfill these types because bigint is a builtin type.
//
// This workaround lets us use them when possible and throws an exception at
// runtime when they aren't.
var BigUint64ArrayShim = (_a = global.BigUint64Array) !== null && _a !== void 0 ? _a : /** @class */ (function () {
    function BigUint64Array() {
        throw new Error("BigUint64Array is not supported on this device");
    }
    return BigUint64Array;
}());
var BigInt64ArrayShim = (_b = global.BigInt64Array) !== null && _b !== void 0 ? _b : /** @class */ (function () {
    function BigInt64Array() {
        throw new Error("BigInt64Array is not supported on this device");
    }
    return BigInt64Array;
}());
var typedArrays = {
    "f64": Float64Array,
    "i64": BigInt64ArrayShim,
    "u64": BigUint64ArrayShim,
    "f32": Float32Array,
    "i32": Int32Array,
    "u32": Uint32Array,
    "u16": Uint16Array,
    "i16": Int16Array,
    "u8": Uint8ClampedArray,
    "i8": Int8Array,
};
/**
 * An opaque tensor.
 */
var Tensor = /** @class */ (function () {
    function Tensor(shape, elements) {
        this.shape = shape;
        this.elements = elements;
    }
    Tensor.prototype.asTypedArray = function (elementType) {
        if (this.shape.type != elementType) {
            throw new Error("Attempting to interpret a ".concat(this.shape.toString(), " as a ").concat(elementType, " tensor"));
        }
        var _a = this.elements, buffer = _a.buffer, byteOffset = _a.byteOffset, byteLength = _a.byteLength;
        var length = byteLength / Shape_1.default.ByteSize[this.shape.type];
        var constructor = typedArrays[elementType];
        return new constructor(buffer, byteOffset, length);
    };
    Object.defineProperty(Tensor.prototype, "elementType", {
        get: function () {
            return this.shape.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tensor.prototype, "dimensions", {
        get: function () {
            return this.shape.dimensions;
        },
        enumerable: false,
        configurable: true
    });
    return Tensor;
}());
exports.default = Tensor;
